import { FloatingBar as Root, FloatingBarBar as Bar } from "./floating-bar";
import { FloatingBarButton as Button } from "./floating-bar-button";
import { FloatingBarDropdown as Dropdown } from "./floating-bar-dropdown";
import { FloatingBarIcon as Icon } from "./floating-bar-icon";
import { FloatingBarGroup as Group } from "./floating-bar-group";
import { FloatingBarProvider as Provider } from "./use-floating-bar";

export const FloatingBar = {
	Root,
	Bar,
	Provider,
	Button,
	Dropdown,
	Icon,
	Group,
};
